// ui-button
export function buttonAppearanceValidator(value) {
    return ['primary', 'secondary', 'tertiary', 'danger', 'delete', 'warning'].includes(value);
}

export function buttonTypeValidator(value) {
    return ['fill', 'outline', 'blank'].includes(value);
}

export function buttonSizeValidator(value) {
    return ['normal', 'small'].includes(value);
}

// ui-modal
export function modalSizeValidator(value) {
    return ['md', 'lg'].includes(value);
}
export function modalImagePropsValidator(value) {
    const validPositions = [
        'center',
        'top',
        'bottom',
    ];

    const hasValidSrc = value && typeof value.src === 'string';
    const hasValidObjectPosition = !value.objectPosition || validPositions.includes(value.objectPosition);

    return hasValidSrc && hasValidObjectPosition;
}
